<template>
  <component
    v-bind="$props"
    :is="logoType"
    :class="{ 'path-fill-current': !useDefaultColor }"
    @click="$emit('click', $event)"
  />
</template>

<script>
import LogoIconOnly from '../../../assets/icons/logo-icon-only.svg'
import Logo from '../../../assets/icons/logo.svg'

export default {
  components: {
    Logo,
    LogoIconOnly,
  },
  props: {
    iconOnly: {
      type: Boolean,
      default: false,
    },
    useDefaultColor: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    logoType() {
      return this.iconOnly ? LogoIconOnly : Logo
    },
  },
}
</script>

<style lang="scss">
.path-fill-current path {
  @apply fill-current;
}
</style>
